import React, { forwardRef, useImperativeHandle, useMemo, useRef } from 'react';
import { Popper, Text } from '@fragments';

// A Menu opened at a point instead of under a trigger (right-click on the art or on a
// layer row). Items take the Menu shape ({ label, icon, shortcut, variant, disabled,
// divider }); the Popper is positioned off a zero-size anchor at the pointer.
const ContextMenu = forwardRef(function ContextMenu(_, ref) {
  const popper = useRef(null);
  const config = useMemo(() => ({ fitContent: true, fitHeight: true }), []);
  useImperativeHandle(ref, () => ({
    open(items, x, y) {
      const anchor = { getBoundingClientRect: () => ({ top: y, bottom: y, left: x, right: x, width: 0, height: 0, x, y }) };
      const options = items.filter(Boolean).map((item, index) => (item.divider ? { divider: true, id: `divider-${index}` } : {
        id: `item-${index}`, label: item.label, icon: item.icon, variant: item.variant || 'default', disabled: item.disabled, onClick: item.onClick,
        right: item.shortcut ? <Text.caption contrast={6} className="menu-kbd">{item.shortcut}</Text.caption> : undefined,
      }));
      popper.current?.open(options, 'bottom-start', anchor);
    },
    close() { popper.current?.close(); },
  }), []);
  return <Popper controlRef={popper} config={config} />;
});

export default ContextMenu;
